import React from 'react';
import './BurgerMenu.scss';

interface BurgerMenuProps {
    onClick?: () => void;
    isOpen?: boolean;
}

const BurgerMenu: React.FC<BurgerMenuProps> = ({ onClick, isOpen = false }) => {
    return (
        <button 
            className="burger-menu-btn"
            onClick={onClick}
            aria-label="Toggle menu"
            aria-expanded={isOpen ? 'true' : 'false'}
        >
            <span className="icon-bar" id="i1"></span>
            <span className="icon-bar" id="i2"></span>
            <span className="icon-bar" id="i3"></span>
        </button>
    );
};

export default BurgerMenu;
